// TODO: why do we use string as a value?
export const RecurringTaskRecurringOptionsType = {
	never: '1',
    on: '2',
    after: '3',
};